import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const observations: ThemeUICSSObject = {
  bg: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(5),

  '.currentObservations': {
    display: 'flex',
    gap: spacing(5),
    flexDirection: 'column',

    '.observation': {
      border: '1px solid',
      borderColor: 'palette.border.article',

      '.observation__header': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing(3),
        borderBottom: '1px solid',
        borderColor: 'palette.border.article',
        p: spacing(5),
        backgroundColor: 'transparent',

        img: {
          width: '18px',
          height: '18px',
        },

        '.observation__header__block': {
          display: 'flex',
          flexWrap: 'nowrap',
          gap: spacing(3),
        },

        '.observation__label': {
          fontWeight: '900',
        },
      },

      '&.marked .observation__header': {
        borderLeft: '4px solid',
        borderLeftColor: 'palette.warning.dark',
        borderColor: 'palette.warning.dark',
        backgroundColor: 'palette.warning.main',
      },

      '.observation__body': {
        display: 'flex',
        gap: spacing(5),
        p: spacing(5),
        alignItems: 'start',

        '.observation__comment': {
          width: '100%',
          maxHeight: 'calc(100vh - 130px)',
          resize: 'vertical',

          '&[style*="height"]': {
            maxHeight: 'unset',
          },

          overflow: 'auto',
          pr: spacing(4),
        },
      },
    },
  },

  '.checkboxes': {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(6),
    '.checkbox': {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(3),
    },
  },
  '.observation': {
    display: 'flex',
    flexDirection: 'column',
    span: {
      fontWeight: 'bold',
    },
    textarea: {
      height: '140px',
    },
  },
  /* PREPEND HERE */
};

export default observations;
